import { render, staticRenderFns } from "./programPackPage.vue?vue&type=template&id=15a4956b&"
import script from "./programPackPage.vue?vue&type=script&lang=ts&"
export * from "./programPackPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports